import { format } from 'date-fns';

import { coerceToDate } from './coerceToDate';

export const toYYYY = (d: Date | string) => format(coerceToDate(d), 'yyyy');

export const toMMYY = (d: Date | string) => format(coerceToDate(d), 'MM/yy');

export const toMMDD = (d: Date | string) => format(coerceToDate(d), 'MM/dd');
